import styled, { keyframes } from "styled-components";

const slideIn = keyframes`
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
`;

export const Bar = styled.progress<{
  $color: string;
}>`
  width: 100%;
  height: 4px;

  &::-webkit-progress-bar {
    border-radius: 5px;
    background-color: ${({ theme }) => theme.colors.neutral[100]};
  }

  &::-webkit-progress-value {
    border-radius: 5px;
    background-color: ${({ $color }) => $color};
    animation: ${slideIn} 0.5s ease-in-out;
    transform-origin: left center;
    animation-fill-mode: forwards;
    transition: width 1s;
  }
`;
